import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { HMFlowService } from "../HMFlowService/hmFlow.service"
import { HMFlowDelegate } from "../HMFlowService/hmFlow.delegate"
import { ConfigService } from "../ConfigService/config.service";
import { ConfigServiceFactory } from "../ConfigService/config.service.factory";

export class HMFlowServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService,
        configService?: ConfigService
    ): HMFlowService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new HMFlowDelegate(httpProvider);
        const resolvedConfigService = configService || ConfigServiceFactory.create(config, spinnerService);
        return new HMFlowService(delegate, authenticationService, resolvedConfigService);
    }
}